import messageResource from "../messageResource";
import ArchiveDialog from "./ArchiveDialog";

export default class ArchiveCustomerDialog extends ArchiveDialog {
    constructor($container) {
        super($container, messageResource.getMessage("common.customer"));
    }
}




// WEBPACK FOOTER //
// ./web/js/panels/ArchiveCustomerDialog.js